const BalanceTreats = ({ value }) => {
  return (
    <span className='flex items-center gap-0 text-current' title='$ALGO Balance'>
      <span className='w-[30px] h-[30px]'>
        <img src='/shitty-treats-transparent.png' alt='shitty treats' width={30} height={30} />
      </span>
      <span className='text-base font-semibold tabular-nums'>{value}</span>
    </span>
  );
};

export default BalanceTreats;
